// extracted by mini-css-extract-plugin
export default {"thanx":"successful_thanx__Q01Si","box":"successful_box__q4iVh","checkIcon":"successful_checkIcon__anDxo","scaleUp":"successful_scaleUp__dMg1v"};